module.exports = __webpack_public_path__ + "img/E-WEB-Goal-12.f86a37eb.svg";